import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Services.css';

// Görsel importları - örnek dosya yolları (kendi projenizdeki yolları kullanın)
// import maviKartImage from '../assets/services/mavi-kart.jpg';
// import istisnaAkdiImage from '../assets/services/istisna-akdi.jpg';
// import yeniGocYasasiImage from '../assets/services/yeni-goc-yasasi.jpg';

const Services = () => {
  const services = [
    {
      id: 1,
      title: "Mavi Kart (Blue Card)",
      image: "/images/services/blue-card.jpg", // Eğer public klasörünü kullanıyorsanız
      // image: maviKartImage, // Eğer import yöntemini kullanıyorsanız
      description: "Avrupa Birliği ülkelerinde ayrıcalık sağlayan aynı zamanda gerekli durumlarda kimlik yerine de geçebilen kart. Sınırsız şekilde Avrupa ülkelerinde ikamet ve çalışma izni sağlar.",
      link: "/hizmetlerimiz/#mavi-kart"
    },
    {
      id: 2,
      title: "İstisna Akdi",
      image: "/images/services/istisna-akdi.jpg",
      // image: istisnaAkdiImage,
      description: "Türkiye'den Almanya'ya götürülen işçilerin, başvuru sürecinden işe başlama dönemine ve işin bitiş zamanına kadar tüm resmi süreçlerini takip ediyoruz.",
      link: "/hizmetlerimiz/#istisna-akdi"
    },
    {
      id: 3,
      title: "Yeni Göç Yasası",
      image: "/images/services/yeni-goc-yasasi.webp",
      // image: yeniGocYasasiImage,
      description: "1 Mart 2021 tarihinde resmi olarak Almanya Federal Hükûmeti tarafından kabul edilen ve yürürlüğe giren kanun süreçlerinde size destek oluyoruz.",
      link: "/hizmetlerimiz/#yeni-goc-yasasi"
    }
  ];

  return (
    <section className="services">
      <div className="container">
        <div className="section-title">
          <h2>Hizmetlerimiz</h2>
        </div>
        <div className="service-cards">
          {services.map(service => (
            <div className="card" key={service.id}>
              <div className="card-img">
                <img 
                  src={service.image} 
                  alt={service.title} 
                  className="service-image"
                />
              </div>
              <div className="card-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <Link to={service.link} className="card-link">Detaylı Bilgi</Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;